import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  UiComponents,
  ProfileIcon,
  SecurityIcon,
  SettingIcon,
  CalenderIcon,
  BackArrowIcon,
  UnoStoreHooks,
} from "@simulanisindia/ui";
import ProfileInformation from "./Profile/ProfileInformation";
import GroupInformation from "./Profile/GroupInformation";
import AddressInformation from "./Profile/AddressInformation";
import Password from "./Security/Password";
import TwoFactorAuthentication from "./Security/TwoFactorAuthontication";
import Notifications from "./Settings/Notifications";
import LinkedAccount from "./Settings/LinkedAccount";
import CloseAccount from "./Settings/CloseAccount";
import ActiveSessions from "./Sessions/ActiveSessions";
import AccountHistory from "./Sessions/AccountHistory";
import apiClient from "../../apiClient";
import { useSelector } from "react-redux";
import { useModalContext } from "../../modal/context/ModalProvider";
import { GROUP_DETAILS, USER_DETAILS } from "../../apiClient/apiEndpoints";
import { checkPermissionExist, modalName } from "../../utils/general";
import { PasswordKeyIcon } from "../../SvgIconsData";
import { PASSWORD_CHANGE_PERMISSION } from "../../constant/permission";

const menuData = [
  {
    id: 1,
    title: "Profile",
    icon: <ProfileIcon />,
    hasDropdown: true,
    id_link: "#personal-info",
    submenu: [
      { title: "Personal Information", id_link: "#personal-info" },
      { title: "Group Information", id_link: "#company-info-tab" },
      // { title: "Address", id_link: "#address" },
    ],
  },
  {
    id: 2,
    title: "Security",
    icon: <SecurityIcon />,
    hasDropdown: true,
    id_link: "#password",
    submenu: [
      { title: "Password", id_link: "#password" },
      // { title: "Two-factor authentication", id_link: "#two-factor" },
    ],
  },

  // {
  //   title: "Settings",
  //   icon: <SettingIcon />,
  //   hasDropdown: true,
  //   id_link: "#setting",
  //   submenu: [
  //     { title: "Notification", id_link: "#notification" },
  //     { title: "Linked account", id_link: "#linked-account" },
  //     { title: "Close account", id_link: "#close-account" },
  //   ],
  // },

  // {
  //   title: "Sessions",
  //   icon: <CalenderIcon />,
  //   hasDropdown: true,
  //   id_link: "#active-sessions",
  //   submenu: [
  //     { title: "Active Sessions", id_link: "#active-sessions" },
  //     { title: "Activity history", id_link: "#activity-history" },
  //   ],
  // },
];

const { SimContainer, SimRow, SimColumns, SimListDropDown, BackButton, NormalGradientButton } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const AccountSetting = ({ isMobileView }) => {
  const navigate = useNavigate();
  const params = useParams();
  const { uuid } = params;
  const [activeTab, setActiveTab] = useState("#personal-info");
  const configData = useUnoSelector((state) => state.config);

  const [userDetails, setUserDetails] = useState({
    name: "",
    emailOrUID: "",
    phone: "",
    designation: "",
    avatar: "",
    password: "",
    role: null,
    active: true,
    loginType: "email",
    signinGoogle: false,
  });

;
  const [groupDetails, setGroupDetails] = useState({
    name: "",
    avatar: "",
    identifier: "",
    designation: "",
    type: null,
    active: true,
  });

  const backClick = () => {
    navigate(-1);
  };

  const handleGetUserDetails = async () => {
    try {
      let data = await apiClient.get(`${configData.config.UNO_URL}${USER_DETAILS}/${uuid}`);
      const roleAllocation =
        data?.roleAllocations?.length > 1
          ? data?.roleAllocations?.filter((e) => e?.role?.type !== "DEFAULT")[0]
          : data?.roleAllocations[0];
      const { role = null } = roleAllocation || { role: null };

      setUserDetails({
        name: data.name,
        email: data.email,
        uid: data.uid,
        phone: data.phone,
        designation: data.designation,
        avatar: data.avatar,
        signinGoogle: data.signinGoogle,
        password: "",
        role: role ? { label: role.name, value: role.id } : null,
        active: data.active,
      });

      setGroupDetails({
        name: data.group.name,
        avatar: data.group.avatar,
        identifier: data.group.identifier,
        active: data.group.active,
        type: data?.group?.type?.id ? { id: data.group.type.id, label: data.group.type.name } : null,
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleGetUserDetails();
  }, [uuid]);

  const renderContent = () => {
    switch (activeTab) {
      case "#personal-info":
        return <ProfileInformation handleGetUserDetails={handleGetUserDetails} userDetails={userDetails} uuid={uuid} />;
      case "#company-info-tab":
        return <GroupInformation groupDetails={groupDetails} handleGetGroupDetails={handleGetUserDetails} />;
      case "#password":
        return <Password userDetails={userDetails} />;
      case "#address":
        return <AddressInformation />;
      case "#two-factor":
        return <TwoFactorAuthentication />;
      case "#notification":
        return <Notifications />;
      case "#linked-account":
        return <LinkedAccount />;
      case "#close-account":
        return <CloseAccount />;
      case "#active-sessions":
        return <ActiveSessions />;
      case "#activity-history":
        return <AccountHistory />;
      default:
        <></>;
    }
  };

  return (
    <>
      {!isMobileView ? (
        <div className="page-title with-fuctions">
          <BackButton onBackClick={backClick} Icon={<BackArrowIcon />} />
          <h5 className="page-heading">Account Settings</h5>
        </div>
      ) : (
        <div className="page-title personaldethead">
          <h5>Personal Details</h5>
   
        </div>
      )}
      <div className="card border-0 accountsetting">
        <div className="card-body">
          <SimContainer fluid>
            <ProfileInformation
              handleGetUserDetails={handleGetUserDetails}
              userDetails={userDetails}
              UUID={uuid}
              isMobileView={isMobileView}
            />
            {!isMobileView && (
              <>
                <GroupInformation groupDetails={groupDetails} handleGetGroupDetails={handleGetUserDetails} />
                { checkPermissionExist(PASSWORD_CHANGE_PERMISSION) &&
                  <Password userDetails={userDetails} isMobileView={isMobileView} />
                }
              </>
            )}

            {/* <SimRow> */}
            {/* <SimColumns sm="3">
                <SimListDropDown
                  menuData={menuData}
                  setActiveTab={setActiveTab}
                  activeTab={activeTab}
                />
              </SimColumns> */}

            {/* <SimColumns sm="9"> */}

            {/* {renderContent()} */}

            {/* <div className="content">
                  <section id="profile" style={{ display: activeTab === "#profile" ? "block" : "none" }}>
                    <div id="personal-info">
                      <ProfileInformation handleGetUserDetails={handleGetUserDetails} userDetails={userDetails} />
                    </div>
                    <div id="company-info-tab">
                      <GroupInformation groupDetails={groupDetails} />
                    </div>
                    <div id="address">
                      <AddressInformation />
                    </div>
                  </section>

                  <section id="security" style={{ display: activeTab === "#security" ? "block" : "none" }}>
                    <div id="password">
                      <Password userDetails={userDetails} />
                    </div>
                    <div id="two-factor">
                      <TwoFactorAuthentication />
                    </div>
                  </section>

                  <section id="setting" style={{ display: activeTab === "#setting" ? "block" : "none" }}>
                    <div id="notification">
                      <Notifications />
                    </div>
                    <div id="linked-account">
                      <LinkedAccount />
                    </div>
                    <div id="close-account">
                      <CloseAccount />
                    </div>
                  </section>

                  <section id="sessions" style={{ display: activeTab === "#sessions" ? "block" : "none" }}>
                    <div id="active-sessions">
                      <ActiveSessions />
                    </div>
                    <div id="activity-history">
                      <AccountHistory />
                    </div>
                  </section>
                </div> */}

            {/* </SimColumns> */}

            {/* </SimRow> */}
          </SimContainer>
        </div>
      </div>
    </>
  );
};

export default AccountSetting;
